/**
 * Runtime environment config shim.
 *
 * At deploy time the Jenkins DEPLOY pipeline injects public/config.js which sets
 * window.__ENV__ before the React bundle loads. This shim reads from there first,
 * then falls back to process.env.REACT_APP_* so local development still works.
 *
 * Usage:
 *   import { env } from '@/lib/env';
 *   const url = env('REACT_APP_BACKEND_URL');
 */

const win = typeof window !== 'undefined' ? window : {};
const runtimeEnv = win.__ENV__ || {};

/**
 * Read a config value — window.__ENV__ takes precedence over process.env.
 * @param {string} key  e.g. 'REACT_APP_BACKEND_URL'
 * @returns {string}
 */
export function env(key) {
  return runtimeEnv[key] || process.env[key] || '';
}

// Convenience named exports for all values used across the app
export const BACKEND_URL            = env('REACT_APP_BACKEND_URL');
export const VIBE_CODING_STUDIO_URL = env('REACT_APP_VIBE_CODING_STUDIO_URL');
export const COGNITO_USER_POOL_ID   = env('REACT_APP_COGNITO_USER_POOL_ID');
export const COGNITO_CLIENT_ID      = env('REACT_APP_COGNITO_CLIENT_ID');
export const API_KEY                = env('REACT_APP_API_KEY');
export const AWS_REGION             = env('AWS_REGION') || 'ca-central-1';
export const ENVIRONMENT            = env('ENVIRONMENT') || 'dev';
